import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import {
  CommunicationLogLookupsModel,
  CommunicationLogModel,
  CommunicationLogDto,
  CommunicationLogTableFields,
  CommunicationLogPagingGetDto,
} from '../../shared-new/models/communication-log.model';
import { MailFacade } from '../../shared-new/store/mail/mail.facade';
import { CommunicationLogDataSource } from './communication-log-datasource';
import { AuthService } from '../../services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommunicationLogDetailModalComponent } from '../communication-log-detail-modal/communication-log-detail-modal.component';
import { EmailEventType } from '../../shared-new/enums/email-activity.enum';
import { MailService } from 'src/app/shared-new/services/mail.service';
import { DateParserFormatter } from '../../utils/helper/date-parser-formatter';
import { LookupModel, SearchDropdownComponent } from '../../shared/search-dropdown/search-dropdown.component';
import { SearchBoxComponent } from '../../shared/search-box/search-box.component';
const limit = 9;
@Component({
  selector: 'app-communication-log',
  templateUrl: './communication-log.component.html',
  styleUrls: ['./communication-log.component.scss'],
})
export class CommunicationLogComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  //public dataSource: CommunicationLogDataSource;
  public dataSource: MatTableDataSource<CommunicationLogModel>;
  public displayedColumns$;
  public isLoader: boolean;
  form: FormGroup;
  public user: any;
  public dateFormat: string = '';
  public communicationLogTableFields = CommunicationLogTableFields;
  communicationLogs$ = this.mailFacade.communicationLogs$;
  communicationErrors$ = this.mailFacade.communicationErrors$;
  public isSaleFeatureEnabled: boolean = false;
  public lotOrHipText: string = "HIP";
  searchText = '';
  selectedSale = '';
  selectedRecipient = '';
  showDropdown = false;
  public lookupsData: CommunicationLogLookupsModel;
  filteredRecipients: any;
  allRecipients: LookupModel[] = [];
  allSales: LookupModel[] = [];
  @ViewChild('salesDropdown') salesDropdown!: SearchDropdownComponent;
  @ViewChild('searchBox') searchBox!: SearchBoxComponent;
  @ViewChild('recipientsDropdown') recipientsDropdown!: SearchDropdownComponent;
  // Pagination State
  public currentPage: number = 1;
  public itemsPerPage: number = 100;
  public totalRecords: number = 0;
  public totalPages: number = 0;

  constructor(
    private mailFacade: MailFacade,
    public readonly authService: AuthService,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private dateParserFormatter: DateParserFormatter,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private mailService: MailService,
    private eRef: ElementRef
  ) {
    super();

    this.authService.getMemberLotOrHipText().subscribe((data) => {
      this.lotOrHipText = data;
    });
    this.authService.getUserData().subscribe((data) => {
      if (data) {
        this.user = JSON.parse(data);
        if (this.user.region === 'USA') {
          this.dateFormat = 'MM/dd/yyyy';
        } else {
          this.dateFormat = 'dd/MM/yyy';
        }
      }
    });


    this.form = CommunicationLogModel.asFormGroup();
    this.isSaleFeatureEnabled = this.authService.GlobalMemberAccessData.isSaleFeatureEnabled;
    if (this.isSaleFeatureEnabled) {
      this.displayedColumns$ = new BehaviorSubject([
        // 'saleImageUrl',
        'sentDateUtc',
        'company',
        'to',
        'mailTypeName',
        'communicationType',
        'subject',
        'saleName',
        'lot',
        'status',
        'open'
      ]);
    }
    else {
      this.displayedColumns$ = new BehaviorSubject([
        'sentDateUtc',
        'company',
        'to',
        'mailTypeName',
        'communicationType',
        'subject',
        'status',
        'open'
      ]);
    }
  }

  ngOnInit(): void {
    this.loadLookups();
  }

  resetFilters() {
    // reset reactive form
    this.form.reset({
      sentMailTypeId: '',
      deliveryTypeId: '',
      sendGridEventId: '',
      search: ''
    });


    // reset dropdown selections (if your dropdown component supports it)
    this.salesDropdown?.clearSelection?.();
    this.recipientsDropdown?.clearSelection?.();

    // trigger your search again if needed
    this.search();
    this.searchBox?.clear();
  }

  handleSelectionReceipients(item: LookupModel) {
    if (item) {
      this.selectedRecipient = item.name;
    } else {
      this.selectedRecipient = '';
    }
    this.onPageSizeChange();
  }

  handleSelectionSales(item: LookupModel) {
    if (item) {
      this.selectedSale = item.name;
    } else {
      this.selectedSale = '';
    }
    //this.search();
    this.onPageSizeChange();
  }

  onPageSizeChange() {
    this.currentPage = 1;
    this.search();
  }

  goToPage(page: number) {
    if (page >= 1) {
      this.currentPage = page;
      this.search();
    }
  }

  private loadLookups() {
    this.mailService.getCommunicationLogLookups().subscribe({
      next: (response: CommunicationLogLookupsModel) => {
        this.lookupsData = response;

        //only attach events after lookups have been successfully loaded.
        this.attachEvents();

        const pagingDto = new CommunicationLogPagingGetDto();
        pagingDto.currentPage = this.currentPage;
        pagingDto.itemsPerPage = this.itemsPerPage;

        this.mailFacade.getCommunicationLogs(pagingDto);
        //this.filteredRecipients = this.dataSource?.getColumnDistinctValues(CommunicationLogTableFields.TO, 'to');        
      },
      error: (err) => {
        if (err) {
          this.httpErrorHandlerService.ShowErrorMessage(err);
        }
      }
    });
  }

  public getColumnDistinctValues(key: string, col: string, dataSet: CommunicationLogModel[]): string[] {
    const distinctValues: Set<string> = new Set();

    dataSet.forEach((row) => {
      type ObjectKey = keyof typeof row;
      const col = key as ObjectKey;
      const cellValue = String(row[col]);
      if (cellValue) {
        distinctValues.add(cellValue);
      }
    });
    if (typeof col != 'undefined' && col == 'to') {
      return Array.from(distinctValues).sort((a, b) => a.localeCompare(b));
    }
    return Array.from(distinctValues);
  }

  private attachEvents() {
    this.communicationLogs$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {

        if (response && typeof response.communicationLogList != 'undefined' && response.communicationLogList.length > 0) {

          this.totalRecords = response.totalRecords;
          this.totalPages = response.totalPages;
          let sortedResult = [...response.communicationLogList].sort((a, b) => {
            const date1 = a.sentDateUtc;
            const date2 = b.sentDateUtc;
            if (date1 >= date2) {
              return -1;
            } else {
              return 1;
            }
          });
          this.dataSource = new MatTableDataSource(sortedResult);
          this.dataSource.sort = this.sort;
        }
        else {
          this.totalRecords = 0;
          this.totalPages = 0;
          this.dataSource = new MatTableDataSource([]);
        }
      });

    this.communicationErrors$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((err) => {
        if (err) {
          this.httpErrorHandlerService.ShowErrorMessage(err);
        }
      });
  }
  getPaginationRange(): (number | string)[] {
    const total = this.totalPages;
    const current = this.currentPage;
    if (total <= 0) {
    return [];
  }


    const delta = 4;
    const range: (number | string)[] = [];

    // Helper to keep track of the last number pushed to avoid Math errors
    let lastAddedNumber = 0;

    const addPage = (page: number) => {
      range.push(page);
      lastAddedNumber = page;
    };

    // 1. Always add the first page
    addPage(1);

    const left = Math.max(2, current - delta);
    const right = Math.min(total - 1, current + delta);

    // 2. Add left ellipsis or transition
    if (left > 2) {
      range.push('...');
    } else if (left === 2) {
      addPage(2);
    }

    // 3. Add the window range
    // We start from the higher of 'left' or 'lastAddedNumber + 1'
    for (let i = Math.max(left, lastAddedNumber + 1); i <= right; i++) {
      addPage(i);
    }

    // 4. Add right ellipsis or transition
    if (right < total - 1) {
      range.push('...');
    } else if (right === total - 1 && lastAddedNumber < total - 1) {
      addPage(total - 1);
    }

    // 5. Always add the last page
    if (total > 1) {
      range.push(total);
    }

    return range;
  }
  
  get startRecord(): number {
    if (this.totalRecords === 0) return 0;
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  get endRecord(): number {
    const end = this.currentPage * this.itemsPerPage;
    return end > this.totalRecords ? this.totalRecords : end;
  }
  // public sortTable(sortBy: keyof CommunicationLogModel): void {
  //   this.dataSource.sort(sortBy);
  // }

  public openLogItem(sentMailLogId: number) {
    const modalRef = this.modalService.open(CommunicationLogDetailModalComponent, {
      size: 'xl',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.sentMailLogId = sentMailLogId;
  }
  public applyFilter(search: string) {
    this.searchText = search;
    this.search();
  }
  public search() {

    const pagingDto = new CommunicationLogPagingGetDto();
    const formValues = this.form.value;
    pagingDto.currentPage = this.currentPage;
    pagingDto.itemsPerPage = this.itemsPerPage;
    pagingDto.search = this.searchText || null;
    pagingDto.deliveryTypeId = formValues.deliveryTypeId ? +formValues.deliveryTypeId : null;
    pagingDto.sentMailTypeId = formValues.sentMailTypeId ? +formValues.sentMailTypeId : null;
    pagingDto.sendGridEventTypeId = formValues.sendGridEventId ? +formValues.sendGridEventId : null;
    pagingDto.saleId = this.lookupsData.allSales.find(s => s.name === this.selectedSale)?.id || null;
    pagingDto.recipientId = this.selectedRecipient || null;
    this.mailFacade.getCommunicationLogs(pagingDto);
    //this.dataSource.searchTable('');

  }

  public getFilters() {
    const form = this.form.value;
    const filters: { key: string; value: string }[] = [];
    Object.keys(form).forEach((key) => {
      if (form[key]) {
        filters.push({
          key: key,
          value: form[key],
        });
      }
    });

    return filters;
  }

  getWhatsAppColorClass(event: any) {
    return `whatsapp-status-box-${event.whatsAppStatusId}`;
  }
  getSMSColorClass(event: any) {
    return `sms-status-box-${event.smsStatusId}`;
  }
  getColorClass(eventType: number) {
    let bevhaviourClassId = this.lookupsData.messageEvents.find(a => a.sendGridEventTypeId == eventType)?.eventBehaviourClassId ?? 3;
    return `study-status-box-${bevhaviourClassId}`;
  }

  //public onTableScroll(): void {
  //  if (!this.isLoader) {
  //    this.dataSource.onScroll();
  //  }
  //}
}
